import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const LayoutActions = createActionGroup({
  source: 'Layout',
  events: {
    'Set Is Mobile': props<{
      isMobile: boolean;
    }>(),

    'Set Sidebar Opened': props<{
      isOpened: boolean;
    }>(),

    'Set Right Panel Opened': props<{
      isOpened: boolean;
    }>(),

    'Set Right Panel Maximized': props<{
      isMaximized: boolean;
    }>(),

    'Clear Layout State': emptyProps(),
  },
});
